import { subjectName } from "@/lib/entities";

const base = "w-full h-10 rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 focus:border-blue-600 focus:ring-2 focus:ring-blue-100 outline-none transition-colors";

export function FieldInput({ f, value, onChange, refs, testId }) {
  const set = (v) => onChange(f.k, v);
  if (f.t === "textarea")
    return <textarea data-testid={testId} className={`${base} h-24 py-2`} value={value ?? ""} onChange={(e) => set(e.target.value)} />;
  if (f.t === "bool")
    return (
      <label className="flex items-center gap-2 h-10 text-sm text-slate-700">
        <input data-testid={testId} type="checkbox" className="h-4 w-4 accent-[#0A2540]" checked={!!value} onChange={(e) => set(e.target.checked)} />
        {f.l}
      </label>
    );
  if (f.t === "select" || f.t === "subject" || f.t === "trust") {
    const options =
      f.t === "subject" ? (refs.subjects || []).map((s) => ({ value: s.id, label: subjectName(s) }))
      : f.t === "trust" ? (refs.trusts || []).map((t) => ({ value: t.id, label: t.name }))
      : f.o;
    return (
      <select data-testid={testId} className={base} value={value ?? ""} onChange={(e) => set(e.target.value)}>
        <option value="">— Seleziona —</option>
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    );
  }
  if (f.t === "account")
    return (
      <>
        <input data-testid={testId} list="coa-list" className={base} value={value ?? ""} onChange={(e) => set(e.target.value)} />
        <datalist id="coa-list">
          {(refs.chart_of_accounts || []).map((a) => <option key={a.id} value={`${a.code} ${a.name}`} />)}
        </datalist>
      </>
    );
  return (
    <input
      data-testid={testId}
      type={f.t === "date" ? "date" : f.t === "number" ? "number" : "text"}
      step={f.t === "number" ? "any" : undefined}
      className={base}
      value={value ?? ""}
      onChange={(e) => set(f.t === "number" && e.target.value !== "" ? Number(e.target.value) : e.target.value)}
    />
  );
}

export const inputClass = base;
